import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import stylingSelector from '../selectors';

const { getStylingBlockMargin } = stylingSelector;

const getStylingBlockMarginCapped = state => getStylingBlockMargin(state);

const mapStateToProps = createSelector(
  getStylingBlockMarginCapped,
  stylingBlockMargin => ({
    stylingBlockMargin,
    marginDomStyles: { margin: `${stylingBlockMargin}px 0` },
  }),
);

export default connect(mapStateToProps);
